module.exports = "https://www.gc-qa.gnp.com.mx/54e1bc1da069bf69bd0adf6c4e45de91.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-ubicacion.png
// module id = 979
// module chunks = 0 1